<template>
  <div class="pay-modal">
    <div class="pay-modal-body">
      <div class="pay-body_box">
        <div class="pay-body_imgbox">
          <canvas class="pay-body_canvas" id="canvas"></canvas>
        </div>
        <div class="pay-body_operat">
          <p class="pay-body_text">微信扫一扫二维码，进行支付</p>
          <el-button type="primary" @click="hanleConfim">完成支付</el-button>
        </div>
      </div>
    </div>
    <div class="pay-shadow" @click="hanleCancel"></div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
export default {
  props: {
    codeUrl: {
      type: String,
      defalut: ''
    }
  },
  created() {
    this.$nextTick(() => {
      this.qrcodeFn(this.codeUrl);
    });
  },
  methods: {
    qrcodeFn(url) {
      QRCode.toCanvas(document.getElementById('canvas'), url, function(error) {
        if (error) console.error(error);
        //console.log("success!");
      });
    },
    hanleCancel() {
      this.$emit('confimClick');
      this.$emit('cancelClick');
    },
    hanleConfim() {
      this.$emit('confimClick');
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  .pay-shadow {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #fff, $alpha: 0.9);
  }
  .pay-modal-body {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    .pay-body_imgbox {
      width: 256px;
      height: 256px;
      margin: auto;
      border: 1px solid #eee;
      .pay-body_canvas {
        display: block;
        width: 100% !important;
        height: 100% !important;
      }
    }
    .pay-body_box {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      z-index: 1000;
    }
    &::after {
      content: '';
      display: inline-block;
      width: 0;
      height: 100%;
      vertical-align: middle;
    }
    .pay-body_text {
      font-size: 14px;
      text-align: center;
      line-height: 40px;
      color: #e50011;
    }
  }
}
</style>
